import { KKSound } from './KKSound';
export default KKSound;
